import React from 'react';

import type { ByfunnFrapiTopTags } from '../../../types/frapi-types.js';

import { console } from '../../../../core/system/console/index.js';
import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';

interface FilterToggleProps {
  sectionId: string;
  hasActiveFilters: boolean;
  setFilters: (filters: ByfunnFrapiTopTags) => void;
  setOpenFilter: (isOpen: boolean) => void;
}

export const FilterToggle: React.FC<FilterToggleProps> = ({
  sectionId,
  hasActiveFilters,
  setFilters,
  setOpenFilter,
}) => {
  const { trackElementClick } = usePulseContext();

  const handleClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    trackElementClick({
      object: {
        id: 'filter:open-filters',
        elementType: 'Button',
        name: `${hasActiveFilters ? 'edit' : 'open'} filters`,
        custom: {
          sectionId,
        },
      },
    }).finally(() => fetchFilters());
  };

  const fetchFilters = async () => {
    try {
      if (sectionId) {
        const raw = await fetch(
          `/api/top-tags?sectionIds=${sectionId}&tagTypes=machine&phrase=vink&limit=120`,
        );
        const result = await raw.json();
        setFilters(result);
        setOpenFilter(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <button className="open-filters" onClick={handleClick}>
      {hasActiveFilters ? 'Endre filter' : 'Åpne filter'}
    </button>
  );
};
